"use strict";
/**
 * Transport shapes of the approved authentication endpoints.
 *
 * Trace: Data & API Design Baseline v1.1 and canonical OpenAPI 1.1.0
 * (`openapi/openapi.yaml`) — operations `login` (AUTH-01), `refresh`
 * (AUTH-02), `logout` (AUTH-03), `getCurrentUser` (AUTH-04) and
 * `listMySessions` (AUTH-05), with the schemas `LoginRequest`,
 * `LoginDeviceDto`, `RefreshRequest`, `TokenPairResponse`, `CurrentUserDto`,
 * `AuthSessionDto` and the `Ack` response. Additive password operations
 * AUTH-07 / IAM-08 / IAM-09 live in the same YAML; this module does not invent
 * extra runtime types for them.
 *
 * The members are transferred one to one from the canonical artifact: no field
 * is added, renamed or made optional here. A change requires change control on
 * the contract first.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_DEVICE_PLATFORMS = void 0;
/** `components.schemas.LoginDeviceDto.platform`. */
exports.LOGIN_DEVICE_PLATFORMS = ['ANDROID', 'WEB'];
//# sourceMappingURL=auth.js.map